import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-message-body-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h1 mat-dialog-title>Message</h1>
    <div mat-dialog-content>
      <p class="message-body-dialog__body">{{ data }}</p>
    </div>
    <div mat-dialog-actions>
      <button mat-button type="button" (click)="dialogRef.close()">Close</button>
    </div>
  `,
  styles: [
    `
      .message-body-dialog__body {
        margin: 0;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
      }
    `,
  ],
})
export class MessageBodyDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MessageBodyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {}
}
